import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Grid,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import GlobalCard from "../../../../components/GlobalCardComponent";

export default function SapPlan() {
  const plans = [
    {
      title: "Quick Boost",
      features: [
        "7 day revision",
        "2 mock tests with feedback",
        "Quick revision of key concepts",
      ],
    },
    {
      title: "Intensive Plan",
      features: [
        "Performance tracking",
        "21 days of lessons, 5 mock tests",
        "Daily Practice & Personalized Tips",
      ],
    },
    {
      title: "Elite Plan",
      features: [
        "1:1 Mentor Support",
        "45 days, 10 full tests",
        "Free Personalized Study Plan",
      ],
    },
  ];
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="center">
          <Typography
            fontSize="27px"
            color="#000000"
            fontFamily="Inter"
            fontWeight={400}
          >
            Choose Your Plan
          </Typography>

          <Typography
            fontSize="18px"
            color="#444444"
            fontFamily="Inter"
            fontWeight={400}
          >
            Starter to Elite — pick the guidance level that fits your journey
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            {plans.map(({ title, features }, index) => (
              <Grid item xs={12} sm={12} md={4}>
                <GlobalCard height="100%">
                  <Typography
                    fontSize="18px"
                    color="#572575"
                    fontFamily="Inter"
                    fontWeight={400}
                  >
                    {title}
                  </Typography>
                  <List>
                    {features.map((feature, i) => (
                      <ListItem key={i} sx={{ py: 0.5 }}>
                        <ListItemIcon
                          sx={{ minWidth: "24px", color: "#ffb703" }}
                        >
                          <StarIcon
                            fontSize="small"
                            sx={{ fontSize: "13px" }}
                          />
                        </ListItemIcon>
                        <Typography
                          fontSize="14px"
                          color="#222222"
                          fontFamily="Inter"
                          fontWeight={400}
                        >
                          {feature}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                  <Button
                    size="small"
                    variant="contained"
                    style={{
                      mt: 3,
                      background: "#572575",
                      textTransform: "none",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                    }}
                  >
                    View More
                  </Button>
                </GlobalCard>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
